module.exports = __webpack_public_path__ + "img/PP.726af381.png";